// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.native-post-title[data-v-20ee0fd7] {
  width: 100%;
  padding-block: 10px;
  border: none;
  font-size: 26px;
  font-weight: 700;
}
.native-post-title[data-v-20ee0fd7]:focus {
  outline: none;
}
.native-post-content[data-v-20ee0fd7] {
  width: 100%;
}
.native-post-content-container[data-v-20ee0fd7] {
  width: 100%;
  position: relative;
}
.native-post-content-container .editor-container[data-v-20ee0fd7] {
  width: 100%;
}
.native-post-content-container .editor-container[data-v-20ee0fd7] .ProseMirror {
  padding-block: 10px;
}
.native-post-content-container .editor-container[data-v-20ee0fd7] .ProseMirror:focus-visible {
  outline: none;
}
[data-v-20ee0fd7] .tiptap {
  /* Placeholder (at the top) */
}
[data-v-20ee0fd7] .tiptap p.is-editor-empty:first-child::before {
  content: attr(data-placeholder);
  float: left;
  height: 0;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/pages/publication/CreatePublicationPost.vue","webpack://./CreatePublicationPost.vue"],"names":[],"mappings":"AAGE;EACE,WAAA;EACA,mBAAA;EACA,YAAA;EAEA,eAAA;EACA,gBAAA;ACHJ;ADKI;EACE,aAAA;ACHN;ADOE;EAkBE,WAAA;ACtBJ;ADKI;EACE,WAAA;EACA,kBAAA;ACHN;ADKM;EACE,WAAA;ACHR;ADKQ;EACE,mBAAA;ACHV;ADKU;EACE,aAAA;ACHZ;ADaA;EACE,6BAAA;ACVF;ADWE;EACE,+BAAA;EACA,WAAA;EACA,SAAA;EACA,oBAAA;ACTJ","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.native-post {\n  &-title {\n    width: 100%;\n    padding-block: 10px;\n    border: none;\n\n    font-size: 26px;\n    font-weight: 700;\n\n    &:focus {\n      outline: none;\n    }\n  }\n\n  &-content {\n    &-container {\n      width: 100%;\n      position: relative;\n\n      .editor-container {\n        width: 100%;\n\n        :deep(.ProseMirror) {\n          padding-block: 10px;\n\n          &:focus-visible {\n            outline: none;\n          }\n        }\n      }\n    }\n\n    width: 100%;\n  }\n}\n\n:deep(.tiptap) {\n  /* Placeholder (at the top) */\n  p.is-editor-empty:first-child::before {\n    content: attr(data-placeholder);\n    float: left;\n    height: 0;\n    pointer-events: none;\n  }\n}\n",".native-post-title {\n  width: 100%;\n  padding-block: 10px;\n  border: none;\n  font-size: 26px;\n  font-weight: 700;\n}\n.native-post-title:focus {\n  outline: none;\n}\n.native-post-content {\n  width: 100%;\n}\n.native-post-content-container {\n  width: 100%;\n  position: relative;\n}\n.native-post-content-container .editor-container {\n  width: 100%;\n}\n.native-post-content-container .editor-container :deep(.ProseMirror) {\n  padding-block: 10px;\n}\n.native-post-content-container .editor-container :deep(.ProseMirror):focus-visible {\n  outline: none;\n}\n\n:deep(.tiptap) {\n  /* Placeholder (at the top) */\n}\n:deep(.tiptap) p.is-editor-empty:first-child::before {\n  content: attr(data-placeholder);\n  float: left;\n  height: 0;\n  pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
